import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_URL = "https://www.laurierroseourika.com";
const DEFAULT_IMAGE = `${SITE_URL}/images/gallery/hero11.jpg`;

const SEO = ({
  title,
  description,
  image = DEFAULT_IMAGE,
  path = "",
  lang = "en",
  schema = null,
}) => {
  const fullUrl = `${SITE_URL}${path}`;
  const fullTitle = title
    ? `${title} | Laurier Rose — Ourika Valley, Morocco`
    : "Laurier Rose — Luxury Villa, Ourika Valley Morocco";

  return (
    <Helmet>
      {/* Primary */}
      <html lang={lang} />
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={fullUrl} />

      {/* Open Graph (Facebook, WhatsApp, LinkedIn previews) */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content="Laurier Rose" />
      <meta property="og:locale" content="en_US" />
      <meta property="og:locale:alternate" content="fr_FR" />
      <meta property="og:locale:alternate" content="de_DE" />

      {/* Twitter / X card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* hreflang for multilingual */}
      <link rel="alternate" hreflang="en" href={`${SITE_URL}${path}`} />
      <link rel="alternate" hreflang="fr" href={`${SITE_URL}${path}`} />
      <link rel="alternate" hreflang="de" href={`${SITE_URL}${path}`} />
      <link rel="alternate" hreflang="x-default" href={`${SITE_URL}${path}`} />

      {/* JSON-LD structured data */}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
